import httpClient from "httpClient"

const get = (request) => {
    
    const pathname = '/dias'
    
    const body = {...request, idUnidade: process.env.REACT_APP_ID_UNIDADE || '' }
    
    return httpClient.post(pathname, body)
    
}


const dias = {
    get,
}

export default dias
